import React from "react";
import { Link } from 'react-router-dom'


function Footer() {
  return (
    <footer>
      <div className="footer-top-area footer-bg">
        <div className="container">
          <div className="row justify-content-between">
            <div className="col-3">
              <div className="footer-widget">
                <div className="f-logo">
                  <Link to="/"><img src="img/logo/blue_logo.png" alt="" /></Link>
                </div>
                <div className="footer-text">
                  <p>Découvrez notre sélection exclusive de vêtements pour animaux et accessoires indispensables.</p>
                </div>
                <div className="footer-contact">
                  <div className="icon"><i className="fas fa-headphones" /></div>
                  <div className="content">
                    <h4 className="title"><a href="tel:54666149">54 666 149</a></h4>
                    <span>Appelez-nous</span>
                  </div>
                </div>
                <div className="footer-social">
                  <ul>
                    <li><a href="https://www.facebook.com/share/1NNNPkN18v/?mibextid=wwXIfr"><i className="fab fa-facebook-f" /></a></li>
                    <li><a href="https://www.instagram.com/kaki_tn?igsh=MjB0cXJiNTg0anYz&utm_source=qr"><i className="fab fa-instagram" /></a></li>
                    <li><a href="https://www.tiktok.com/@kaki_tn?_r=1&_t=ZS-9232ML67jxC"><i className="fab fa-tiktok" /></a></li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-2">
              <div className="footer-widget">
                <h4 className="fw-title">Nos Politiques</h4>
                <div className="fw-link">
                  <ul>
                    <li><Link to="/politique-confidentialite">Politique de Confidentialité</Link></li>
                    <li><Link to="/termes-conditions">Termes et Conditions</Link></li>
                    <li><Link to="/politique-retour">Politique de Retour</Link></li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-2">
              <div className="footer-widget">
                <h4 className="fw-title">Nos Services</h4>
                <div className="fw-link">
                  <ul>
                    <li><Link to="/shop">Boutique</Link></li>
                    <li><Link to="/coming-soon">Adoption</Link></li>
                    <li><Link to="/contacts">Contactez-nous</Link></li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-3">
              <div className="footer-widget">
                <h4 className="fw-title">Instagram</h4>
                <div className="fw-insta">
                  <ul>
                    <li><a href="https://www.instagram.com/kaki_tn?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="><img src="img/images/insta_img01.png" alt="" /></a></li>
                    <li><a href="https://www.instagram.com/kaki_tn?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="><img src="img/images/insta_img02.png" alt="" /></a></li>
                    <li><a href="https://www.instagram.com/kaki_tn?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="><img src="img/images/insta_img03.png" alt="" /></a></li>
                    <li><a href="https://www.instagram.com/kaki_tn?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="><img src="img/images/insta_img04.png" alt="" /></a></li>
                    <li><a href="https://www.instagram.com/kaki_tn?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="><img src="img/images/insta_img05.png" alt="" /></a></li>
                    <li><a href="https://www.instagram.com/kaki_tn?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="><img src="img/images/insta_img06.png" alt="" /></a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-shape"><img src="img/images/footer_shape01.png" alt="" /></div>
        <div className="footer-shape shape-two"><img src="img/images/footer_shape02.png" alt="" /></div>
      </div>
      <div className="copyright-area">
        <div className="container">
          <div className="row">
            <div className="col-md-8">
              <div className="copyright-text">
                <p>Droit d'auteur © 2025 Kaki. Tous droits réservés.</p>
              </div>
            </div>
            <div className="col-md-4 d-none d-md-block">
              <div className="footer-lang">
                <div className="dropdown">
                  <button className="dropdown-toggle" type="button" id="dropdownMenuButton2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <img src="img/icon/france.png" alt="" /> Français
                  </button>
                  <div className="dropdown-menu" aria-labelledby="dropdownMenuButton2">
                    {/* <Link className="dropdown-item" to="/"><img src="img/icon/russia.png" alt="" />Russia</Link>
                    <Link className="dropdown-item" to="/"><img src="img/icon//thailand.png" alt="" />Thailand</Link>
                    <Link className="dropdown-item" to="/"><img src="img/icon/india.png" alt="" />India</Link> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>

  )
}

export default Footer;
